import React from 'react';
import { Link } from 'react-router-dom';

export function Header() {
  return (
    <header className="bg-white shadow-sm sticky top-0 z-50">
      <div className="container mx-auto px-4 py-3 flex justify-between items-center text-left">
        <Link to="/" className="flex items-center">
          

        </Link>
        <nav className="hidden md:flex space-x-6">
          
          
        </nav>
        





      </div>
    </header>);

}